import AdminQnaTable from "../../components/Admin/AdminQnaTable";

function AdminQna() {
  return <AdminQnaTable></AdminQnaTable>;
}

export default AdminQna;
